module.exports = __webpack_public_path__ + "img/UpstreamNZ Badges-05.a7add23a.png";